import type { Action, Mutation } from 'vuex'

import actionTypes from './actionTypes'

export interface State {
  modalShowed: boolean
  hint: string
  confirmCallback: Function | null
  cancelCallback: Function | null
}

const state = (): State => ({
  modalShowed: false,
  hint: '',
  confirmCallback: null,
  cancelCallback: null,
})

const actions: { [actionType: string]: Action<State, any> } = {
  [actionTypes.SET_MODAL_STATUS]({ commit }, status: boolean) {
    commit(actionTypes.SET_MODAL_STATUS, status)
  },

  [actionTypes.SET_MODAL_HINT]({ commit }, text: string) {
    commit(actionTypes.SET_MODAL_HINT, text)
  },

  [actionTypes.SET_CONFIRM_CALLBACK]({ commit }, callback: Function) {
    commit(actionTypes.SET_CONFIRM_CALLBACK, callback ?? null)
  },

  [actionTypes.SET_CANCEL_CALLBACK]({ commit }, callback: Function) {
    commit(actionTypes.SET_CANCEL_CALLBACK, callback ?? null)
  },
}

const mutations: { [actionType: string]: Mutation<State> } = {
  [actionTypes.SET_MODAL_STATUS](state, status: boolean) {
    state.modalShowed = status
  },

  [actionTypes.SET_MODAL_HINT](state, text: string) {
    state.hint = text
  },

  [actionTypes.SET_CONFIRM_CALLBACK](state, callback: Function | null) {
    state.confirmCallback = callback
  },

  [actionTypes.SET_CANCEL_CALLBACK](state, callback: Function | null) {
    state.cancelCallback = callback
  },
}

export { actionTypes }

export default {
  namespace: true,
  state,
  actions,
  mutations,
}
